module.exports = __webpack_public_path__ + "img/5.85f58002.jpg";